export const EVENT_MARVEL_RIVALS_ENTER_GAME = "EVENT_MARVEL_RIVALS_ENTER_GAME";
export const EVENT_MARVEL_RIVALS_EXIT_GAME = "EVENT_MARVEL_RIVALS_EXIT_GAME";
